module.exports = __webpack_public_path__ + "img/bili.d53bf4f7.png";